(() => {
  const area = document.getElementById('design-quote');
  if (!area) return;
  const qualityMessage = 'Please upload a clear logo, photo, or sketch. Use a sharp, uncropped JPG, PNG, PDF, SVG, AI or EPS when possible. Blurry, tiny, corrupted, or unreadable artwork cannot be used for an accurate neon proof.';
  const requiredMessage = 'Please upload your logo, photo, or sketch before submitting this logo/artwork request.';
  function fileInput(form){ return form.querySelector('input[type="file"][name]'); }
  function projectIsLogo(form){
    const checked=[...form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked')].map(x=>x.value+' '+(x.id&&document.querySelector('label[for="'+x.id+'"]')?.textContent||'')).join(' ');
    const details=(form.querySelector('[name="text-3"]')?.value||'')+' '+checked;
    return /logo|artwork|photo|sketch/i.test(details);
  }
  function userFiles(input){
    return [...(input?.files||[])].filter(f=>!/miami-neons-design-preview/i.test(f.name));
  }
  function show(input,msg){
    let note=input?.closest('.globo-form-control, .globo-form-input')?.querySelector('[data-mn-upload-error]');
    if(!note&&input){
      note=document.createElement('p'); note.dataset.mnUploadError=''; note.setAttribute('role','alert');
      note.style.cssText='margin-top:8px;color:#b42318;font-weight:600;line-height:1.35';
      input.closest('.globo-form-control, .globo-form-input')?.append(note);
    }
    if(note) note.textContent=msg||'';
  }
  area.addEventListener('change',e=>{
    if(e.target.type!=='file')return;
    const files=userFiles(e.target);
    if(!files.length){show(e.target,'');return;}
    const bad=files.find(f=>!f.size || f.size<1500 || f.size>25*1024*1024 || !/image|pdf|postscript|illustrator|svg/i.test((f.type||'')+' '+f.name));
    show(e.target,bad?qualityMessage:'');
  },true);
  area.addEventListener('submit',e=>{
    const form=e.target;if(!(form instanceof HTMLFormElement))return;
    const input=fileInput(form); if(!input)return;
    if(projectIsLogo(form)&&!userFiles(input).length){
      e.preventDefault();e.stopImmediatePropagation();show(input,requiredMessage);input.focus();input.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    const bad=userFiles(input).find(f=>!f.size || f.size<1500 || f.size>25*1024*1024);
    if(bad){e.preventDefault();e.stopImmediatePropagation();show(input,qualityMessage);input.focus();}
  },true);
  const style=document.createElement('style');
  style.textContent='.mn-launch-notices{max-width:1180px;margin:18px auto 8px;padding:16px 18px;border:1px solid rgba(0,0,0,.12);border-radius:12px;background:#fff;font-size:14px;line-height:1.5}.mn-launch-notices p{margin:6px 0}.mn-launch-notices strong{font-weight:700}';
  document.head.append(style);
})();